var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuBankingStatementsSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8664_5342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41418 18.591L6.41437 18.591V18.6048C6.41437 19.6764 7.11274 20.5001 7.94329 20.5001H18.4955V5.27715C18.4955 4.29818 17.7298 3.53102 16.8174 3.53102H6.04134V3.8276V5.12109L6.41418 18.591Z",
    fill: "white",
    stroke: "#0E5CF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17635 5.36435C6.17635 4.3347 5.34165 3.5 4.31199 3.5C3.28234 3.5 2.44764 4.3347 2.44764 5.36435V7.2287H6.17635V5.36435Z",
    fill: "white",
    stroke: "#0E5CF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12763 19.4979C9.12763 19.8513 9.0344 20.1826 8.87127 20.469L20.2632 20.469C21.1904 20.469 21.7806 19.8587 21.7806 19.2877V18.1318C21.7806 17.8856 21.581 17.6861 21.3348 17.6861L10.8298 17.6861L10.8382 17.7208L10.1709 17.6877C10.1497 17.6866 10.1282 17.6861 10.1066 17.6861C9.47674 17.6861 9.12763 18.0955 9.12763 18.4187L9.12763 19.4979Z",
    fill: "white",
    stroke: "#0E5CF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07703 14C10.3732 12.485 11.0215 11.2727 11.0215 10.3636C11.0215 9 10.6326 9 10.2437 9C9.8548 9 9.45347 9.49318 9.46592 10.3636C9.47914 11.2945 10.1107 12.5805 10.4381 13.0909C11.0215 14 11.4104 14.2273 11.7992 13.5455L12.577 12.1818C12.7065 13.3941 13.0954 14 13.7437 14C13.9498 14 14.77 13.0909 14.9104 13.0909C15.1114 13.0909 15.5003 13.3941 16.077 14",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8664_5342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0770264)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuBankingStatementsSelected);
export default __webpack_public_path__ + "static/media/ic-menu-banking-statements-selected.7b747ec5af8ba4151e4fd07fd384087f.svg";
export { ForwardRef as ReactComponent };